import React from 'react';
import PartnerOfferingList from './PartnerOfferingList';

const PartnerProductList = () => {
  return <PartnerOfferingList offeringKind="Product" pageTitle="Partner Products" />;
};

export default PartnerProductList;
